<template>
  <div class="page-content" :style="defaultHeight">
    <div class="startTitle">机构入驻</div>
    <el-row style="margin-top: -15%;top: 50%;position: relative;">
      <el-col class="zizhiAuthbox" :span="4" :offset="7">
        <img src="../../assets/images/back/p_zhuanjia.png" alt="">
        <h3>我是专家</h3>
        <div class="sub-cont">专业人员入驻审核</div>
        <el-button type="info" @click="tozj()" class="">申请入驻</el-button>
      </el-col>
      <el-col class="zizhiAuthbox" :span="4" :offset="2">
        <img src="../../assets/images/back/p_jigou.png" alt="">
        <h3>我是机构</h3>
        <div class="sub-cont">机构入驻审核</div>
        <el-button type="info" @click="toJigou()" class="">申请入驻</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/assets/css/backcommon.css'
import { mechanismSettleIn } from '@/api/myInfo'
export default {
  name: "zizhiAuth",
  data () {
    return {
      defaultHeight: {
        height: ""
      },
      userId: this.$store.state.user.info
    }
  },
  components: {},
  mounted () {
    // this.queryRealById();
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
  },
  methods: {
    //定义方法，获取高度减去头尾
    getHeight () {
      this.defaultHeight.height = window.innerHeight - 105 + "px";
    },
    toJigou () {
      this.$router.push('/personCenter/zizhiAuth/zizhiAuthJigou_jbxx');
    },
    tozj () {
      this.$router.push('/personCenter/zizhiAuth/zizhiAuthZj_smrz');
    },
    /*queryRealById(){
        queryRealById(this.userId).then(res => {
            console.log(res);
            /!*if (response.code == 200) {
                console.log(response);

            }*!/
        })
    },*/

  },

}
</script>

<style scoped>
.el-row {
  margin-top: 150px;
}
.dmh-btn {
  display: inline-block;
}
.zizhiAuthbox img {
  /*border: 1px dashed #333333;*/
  width: 100px;
  height: 100px;
  display: block;
  margin: 0 auto;
  margin-bottom: 15px;
}

.zizhiAuthbox h3 {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.zizhiAuthbox .sub-cont {
  font-size: 14px;
  color: #717171;
  text-align: center;
  padding-top: 10px;
}

.el-button--info {
  font-size: 12px;
  padding: 10px 30px;
  display: block;
  margin: 20px auto;
}

.zizhiAuthbox button {
  background: #14c86c;
  color: #fff;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  border: none;
  padding: 0 40px !important;
}
.zizhiAuthbox button:hover {
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/views/personCenter/zizhiAuth.vue